import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export const useAdminAuth = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(`${API}/api/auth/me`, { credentials: "include" });
                if (!res.ok) throw new Error();
                setUser(await res.json());
            } catch {
                navigate("/admin/login", { replace: true });
            }
        })();
    }, [navigate]);

    const logout = async () => {
        await fetch(`${API}/api/auth/logout`, { method: "POST", credentials: "include" });
        navigate("/admin/login", { replace: true });
    };

    const hasPermission = (permission) =>
        Boolean(user?.permissions?.includes("*") || user?.permissions?.includes(permission));

    return { user, logout, hasPermission };
};

export const AdminLoading = () => (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC]" data-testid="admin-loading">
        <div className="h-7 w-7 animate-spin rounded-full border-2 border-[#0B1120] border-t-transparent" />
    </div>
);
